<section class="financiamiento-section">
    <div class="financiamiento-overlay"></div>
    <div class="hero-container">
        <h1 class="hero-title animate-hero-title">
            Comercio Exterior (COMEX)
        </h1>
    </div>
</section>

<section class="services-detail-section" #servicesSection>
    <div class="container">
        <div class="services-detail-content">

            <!-- Columna izquierda: Texto + Imagen -->
            <div class="services-left">
                <h2 class="services-intro animate-on-scroll" [class.visible]="isVisible" style="--delay: 0s">
                    Acompañamos a empresas que importan o exportan para optimizar sus operaciones internacionales.
                </h2>
                <div class="services-image animate-on-scroll" [class.visible]="isVisible" style="--delay: 0.2s">
                    <img src="/assets/Tarjetas servicios/5 COMEX.jpg" alt="Comercio Exterior COMEX">
                </div>
            </div>

            <!-- Columna derecha: Lista de servicios -->
            <div class="services-right" style="margin-top: -20px;">
                <ul class="services-list">
                    <li class="service-item animate-on-scroll" [class.visible]="isVisible" style="--delay: 0.3s">
                        <span class="service-icon">+</span>
                        <span class="service-text">Asesoramiento integral en Comercio Exterior.</span>
                    </li>
                    <li class="service-item animate-on-scroll" [class.visible]="isVisible" style="--delay: 0.4s">
                        <span class="service-icon">+</span>
                        <span class="service-text">Estrategia financiera para importaciones y exportaciones.</span>
                    </li>
                    <li class="service-item animate-on-scroll" [class.visible]="isVisible" style="--delay: 0.5s">
                        <span class="service-icon">+</span>
                        <span class="service-text">Evaluación de costos de operaciones internacionales.</span>
                    </li>
                    <li class="service-item animate-on-scroll" [class.visible]="isVisible" style="--delay: 0.6s">
                        <span class="service-icon">+</span>
                        <span class="service-text">Asesoramiento en financiamiento para operaciones de comercio
                            exterior.</span>
                    </li>
                    <li class="service-item animate-on-scroll" [class.visible]="isVisible" style="--delay: 0.7s">
                        <span class="service-icon">+</span>
                        <span class="service-text">Coordinación con despachantes de aduana.</span>
                    </li>
                    <li class="service-item animate-on-scroll" [class.visible]="isVisible" style="--delay: 0.8s">
                        <span class="service-icon">+</span>
                        <span class="service-text">Seguimiento documental de operaciones.</span>
                    </li>
                    <li class="service-item animate-on-scroll" [class.visible]="isVisible" style="--delay: 0.9s">
                        <span class="service-icon">+</span>
                        <span class="service-text">Asistencia en normativa cambiaria relacionada con COMEX.</span>
                    </li>
                    <li class="service-item animate-on-scroll" [class.visible]="isVisible" style="--delay: 1s">
                        <span class="service-icon">+</span>
                        <span class="service-text">Desarrollo de nuevos mercados.</span>
                    </li>
                </ul>
            </div>

        </div>
    </div>
</section>

<app-cta-section></app-cta-section>